import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../features/posts/postsSlice";
import Loading from "../Others/Loading";
import Post from "./Post";

const Posts = () => {
  const dispatch = useDispatch();
  const { posts, filteredPosts, isLoading, isError, error } = useSelector(
    (state) => state.posts
  );
  console.log(filteredPosts)

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  let content;

  if (isLoading) content = <Loading />;
  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && posts?.length === 0) {
    content = <div className="col-span-12">No posts found!</div>;
  }

  if (!isError && !isLoading && posts?.length > 0) {
    content = filteredPosts.map((post) => (
      <Post key={post.id} post={post} />
    ));
  }

  return (
    <main className="post-container" id="lws-postContainer">
      {content}
    </main>
  );
};

export default Posts;
